"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _modal = require("baseui/modal");

var _react = _interopRequireDefault(require("react"));

var _Close = _interopRequireDefault(require("./Close"));

var _constants = require("./constants");

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This is a basic modal with a close button based on
 * [baseui modal](https://baseweb.design/components/modal/).
 * There's no helpers for the modal content, so that's up to you.
 */
const Modal = props => {
  const {
    position = _constants.Position.CENTER,
    zIndex,
    closeType,
    overrides,
    unstable_ModalBackdropScroll = true,
    size,
    ...buiModalProps
  } = props;

  const CloseButton = props => /*#__PURE__*/_react.default.createElement(_Close.default, _extends({}, props, {
    closeType: closeType
  }));

  const buiSize = size === 'mobile' ? 'default' : size;
  return /*#__PURE__*/_react.default.createElement(_modal.Modal, _extends({}, buiModalProps, {
    unstable_ModalBackdropScroll: unstable_ModalBackdropScroll,
    size: buiSize,
    overrides: {
      Close: CloseButton,
      Dialog: {
        style: (0, _style.getDialogStyle)(size)
      },
      DialogContainer: {
        style: (0, _style.getDialogContainerStyle)(position)
      },
      Root: {
        style: (0, _style.getRootStyle)(zIndex)
      },
      // Work around bad baseui flow types
      ...(overrides || {})
    }
  }));
};

var _default = Modal;
exports.default = _default;